import React from 'react';
import { Plus, Compass } from 'lucide-react';

import LinkButton from './LinkButton';
import css from './CTABanner.module.css';

const CTABanner = () => {
  return (
    <section className={css.banner}>
      <div className={css.inner}>
        <h2 className={css.title}>Your next event, or your next booking, starts here.</h2>
        <p className={css.sub}>
          Join 750+ hiring companies and providers already running their pipeline on WLE.
          It's free to post and free to browse.
        </p>
        <div className={css.ctas}>
          <LinkButton name="NewListingPage" variant="primary" large className={css.lightBtn}>
            <Plus />
            Post an event
          </LinkButton>
          <LinkButton name="SearchPage" variant="outlineLight" large>
            <Compass />
            Browse opportunities
          </LinkButton>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
